/*
  AUTHOR - KHYATI RADADIYA
  COMPANY NAME - RADIX ANALYTICS
  Version - 1
  Change log
    -------------------------------------------------------------------
    Date         Author   Comment
    -------------------------------------------------------------------
    2023-11-28	  Khyati   This is store where APIs data will be stored
*/

import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { composeWithDevTools } from "redux-devtools-extension";

import rootReducer from "../reducers/index";

const persistConfig = {
  key: "root",
  storage,
  // Blacklist reducers that store transient API response data. This ensures that on page refresh, these states are reset to their initial values, preventing stale toasts.
  blacklist: [
    "generateVidoPD",
    "videoUploadReducer",
    "userTypeAgainstLoanList",
    "sendOTP",
    "forgotPassword",
    "verifyForgotPassword",
    "resetPassword",
    "addUserData",
    "editUser",
    "userStatus",
    "videoRecordingStartReducer",
    "generateIndividualVideoPd",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk))
);
const persistor = persistStore(store);

export { store, persistor };
export default store;
